import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const getMyPlans = createAsyncThunk(
  "workerPlans/getMyPlans",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/memberships/plans`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

const workerPlansSlice = createSlice({
  name: "workerPlans",
  initialState: {
    workerPlansData: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMyPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.workerPlansData = action.payload;
      })
      .addCase(getMyPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default workerPlansSlice.reducer;